import FullScreenModalTemplate from './FullScreenModalTemplate'

export default FullScreenModalTemplate
